export default __webpack_public_path__ + "static/indoor4-acacd2927570dfa7ad1fcb8aabc8e4af.webp";